import React from 'react';

import Typography from "@material-ui/core/Typography";

import useStyles from "./styles";
import Grid from "@material-ui/core/Grid";

import CMMLogo from "../../../assets/images/cover-my-meds-icon.png"
import addIcon from "../../../assets/images/add-icon.png";
import faxIcon from "../../../assets/images/fax-icon.png";
import {Link} from 'react-router-dom';
import Hidden from "@material-ui/core/Hidden";

const faxFormURL = '/cms/medicalrx/static-assets/documents/provider/forms-and-information/Medi-Cal_Rx_PA_Request_Form.pdf';

const Create = () => {
    const classes = useStyles();
    return (
        <Grid container id="MEDCAL_RX_CREATE_HOME" spacing={0}>
            <h1 className="pageTitle">Create PA</h1>
            <Hidden smDown>
                <Grid item md={4}/>
            </Hidden>
            <Grid item xs={12} md={4} className={classes.center}>
                <div>
                    <div className={classes.mainIcon}>
                        <a href="https://www.covermymeds.health/prior-authorization-forms/prime" target="_blank" rel="noopener noreferrer">
                            <img src={CMMLogo} alt="Cover My Meds" className={classes.mainIconImage}/>
                        </a>
                    </div>
                </div>
                <Typography className={classes.standOutText}>
                    <span id="MEDCAL_RX_CREATE_HOME_OPTION_1">
                        Prescribers: Save time and, often, receive real-time determinations by submitting electronically through CoverMyMeds.
                        Please go to <a href="https://www.covermymeds.health/prior-authorization-forms/prime" target="_blank" rel="noopener noreferrer">https://www.covermymeds.com</a> for more information.
                    </span>
                </Typography>
            </Grid>
            <Hidden smDown>
                <Grid item md={4}/>
            </Hidden>
            <Hidden smDown>
                <Grid item md={2}/>
            </Hidden>
            <Grid item xs={12} md={4} className={classes.center}>
                <div className={classes.secondaryIcon}>
                    <Link to="/create/pa">
                        <img src={addIcon} alt="Create New PA on the Portal" className={classes.mainIconImage}/>
                    </Link>
                </div>
                <Typography className={classes.standOutText}>
                    <span id="MEDCAL_RX_CREATE_HOME_OPTION_2">
                        Continue to <Link to="/create/pa"><b>Create New PA</b></Link> on the Portal.
                    </span><br/>
                    <span className={classes.smallText}>
                        If your PA request is for a newborn infant or transplant donor who is not actively enrolled in
                        Medi-Cal Rx, please submit your PA request via fax. Click <a href={faxFormURL} target="_blank" rel="noopener noreferrer" style={{fontWeight: "bold"}}>here</a> to
                         download the Medi-Cal Rx PA fax form.
                    </span>
                </Typography>
            </Grid>
            <Grid item xs={12} md={4} className={classes.center}>
                <div className={classes.secondaryIcon}>
                    <a href={faxFormURL} target="_blank" rel="noopener noreferrer">
                        <img src={faxIcon} alt="Download a manual PA Fax Form." className={classes.mainIconImage}/>
                    </a>
                </div>
                <Typography className={classes.standOutText}>
                    <span id="MEDCAL_RX_CREATE_HOME_OPTION_3">
                        Click <a href={faxFormURL} target="_blank" rel="noopener noreferrer">here</a> to download a manual PA Fax Form.
                    </span>
                </Typography>
            </Grid>
            <Hidden smDown>
                <Grid item md={2}/>
            </Hidden>
        </Grid>
    )
};

export default Create;
